import * as React from 'react';
import {none, Option} from "ts-option";
import IndividualContact from "../../../model/contact/IndividualContact";
import SelectContactComponent from "./SelectContactComponent";
import ContactSelectorPresenter from "./ContactSelectorPresenter";
import {FocusableProps} from "../../common/props/FocusableProps";
import {PressableProps} from "../../common/props/PresableProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import SelectComponent from "../../ui/select/SelectComponent";
import {RootState} from "../../../store/reducer/root/RootState";
import {Dispatch} from "redux";
import {fetchIndividualContacts} from "../../../store/action/contacts/contacts";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {connect} from "react-redux";

interface ReduxProps {
	/**
	 * Indicates if all contacts are fetched
	 */
	allContactsFetched: boolean
}

interface ComponentProps {
	/**
	 * Id of a selected element.
	 */
	selectedId: Option<string>;
	/**
	 * Callback on changed selection.
	 * @param selected element.
	 */
	onChanged: (selected: Option<IndividualContact>) => void;
	/**
	 * On input change event.
	 * @param {string} value Value of the input/
	 */
	onInputChange?: (value: string) => void;
	/**
	 * Selected contact.
	 */
	contactId: Option<string>;
}

interface DispatchProps {
	/**
	 * Fetch all individual contacts
	 */
	fetchContacts: () => void;
}

type Props = ComponentProps & FocusableProps & PressableProps & PlaceholderProps & ReduxProps & DispatchProps;

class ContactSelector extends React.PureComponent<Props, {}> {
	refs: {
		//TODO figure out proper typings for redux connected component
		SelectContactComponent: any
	};

	componentDidMount(): void {
		if (!this.props.allContactsFetched) {
			this.props.fetchContacts();
		}
	}

	render() {
		return (
			<div>
				{
					this.props.contactId.map(id => {
						return (
							<ContactSelectorPresenter contactId={id}
													  onClick={() => this.props.onChanged(none)}
													  onReset={() => this.resetSelectedContact()}/>
						);
					}).orNull
				}
				<SelectContactComponent ref={"SelectContactComponent"}
										selectedId={this.props.selectedId}
										onInputChange={this.props.onInputChange}
										focus={this.props.focus}
										onFocus={this.props.onFocus}
										onChanged={this.props.onChanged}
										onEnter={this.props.onEnter}
										placeholder={this.props.placeholder}
										visible={this.props.contactId.isEmpty}/>
			</div>
		);
	}

	/**
	 * Reset selected address and clears the input field.
	 */
	resetSelectedContact() {
		//SelectContactComponent is connected to the redux so I need get wrapped instance to get actual SelectComponent methods.
		this.props.onChanged(none);
		if (this.refs.SelectContactComponent)
			(this.refs.SelectContactComponent.getWrappedInstance() as SelectComponent<IndividualContact>).resetSearchInput();
	}
}

function mapStateToProps(state: RootState) {
	return {
		allContactsFetched: state.contact.allContactsFetched
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchContacts: () => dispatch(fetchIndividualContacts(() => {},
			(err) => {notifyBugsnagAndShowToast(err, 'Fetch contacts')}))
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactSelector)